import { useState } from "react";
import { api } from "@/lib/api";
import { useProfile } from "@/context/ProfileContext";
import { Loader2, ShoppingBag } from "lucide-react";
import { toast } from "sonner";
import { getRef } from "@/lib/ref";

export const CheckoutButton = ({ source, label, className, testId, disabled }) => {
  const { profile } = useProfile();
  const [loading, setLoading] = useState(false);

  const go = async () => {
    if (!profile) return;
    setLoading(true);
    try {
      const { data } = await api.post(`/checkout/${profile.id}`, { source, ref: getRef() });
      if (data.skipped?.length) toast.info(`Non disponibili, esclusi: ${data.skipped.join(", ")}`);
      if (data.substituted?.length) toast.info(`Variante non disponibile, sostituita: ${data.substituted.join("; ")}`, { duration: 8000 });
      toast.success(`Checkout pronto · sconto ${data.discount_code} applicato`);
      window.location.assign(data.checkout_url);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Impossibile creare il checkout");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button data-testid={testId} onClick={go} disabled={loading || disabled}
      className={`inline-flex items-center justify-center gap-2 transition-colors disabled:opacity-60 ${className}`}>
      {loading ? <Loader2 className="animate-spin" size={16} /> : <ShoppingBag size={16} />} {label}
    </button>
  );
};
